import marketing from './marketing'
import notFound from './notFount'
import unicomRoute from './other'
import privateRoute from './private'
const routes: IRouter[] = [...marketing, ...notFound, ...privateRoute, ...unicomRoute]
export default routes
